import { gql } from '@apollo/client';

export default gql`
  fragment PlanDetails on Plan {
    id
    databaseId
    identifier
    limits {
      userMaxCount
      projectMaxCount
      videoMaxSeconds
      videoMaxBytes
    }
    price
    title
    weight
  }
`;
